import React, { createContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoEvents } from '../../../../types/app/signal';
import { ConnectionStatus } from '../custom.d';
import { socketManager } from '../services/socket-manager';

const OFFLINE_ROUTE = '/offline';

export const SocketContext = createContext(socketManager.getSocket());


export const SocketWrapper = ({ children }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<ConnectionStatus>(ConnectionStatus.DISCONNECTED);
  const [connection, setConnection] = useState(socketManager.getSocket());


  useEffect(() => {
    const handleOffline = () => {
      console.warn('[SocketManager] Browser offline');
    };
    const handleOnline = () => {
      console.info('[SocketManager] Browser online');
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  useEffect(() => {
    socketManager.onStatusChange((newStatus) => {
      setStatus(newStatus);
    });


    socketManager!.getSocket()!.on(IoEvents.changeTo, (data) => {
      if (!window.location.href.includes('/api/ssr/greeting/')) return;
      console.log(`[Signal]: Received ${IoEvents.changeTo} event with data:`, { data });
      const url = `/api/ssr/greeting/${data.id}?_=${Date.now()}`;

      window.location = window.location.origin + url;
    });

    return () => {
      socketManager.disconnect();
    }
  }, [navigate]);

  return (<SocketContext.Provider value={connection}>
           {children}
          </SocketContext.Provider>);
};
